import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { colors } from 'bl-common/src/constants/colors'
import { LinkArrow } from 'bl-common/src/elements/Arrow/Arrow'
import { Type } from 'bl-common/src/elements/Typography/Typography'
import { mediaObj } from 'bl-common/src/utils/media'

const ArrowWrap = styled.span({
  paddingLeft: '16px',
  transition: 'transform 200ms',
})

const ReadMoreContainer = styled.div({
  display: 'flex',
  alignItems: 'center',

  [mediaObj.md]: {
    '&:hover': {
      [ArrowWrap]: {
        transform: 'translateX(4px)',
      },
    },
  },
})

export const ReadMore = () => {
  const { t } = useTranslation()

  return (
    <ReadMoreContainer>
      <Type preset="labelSmall" color={colors.deepBlue} weight="bold">
        {t('showMoreStories')}
      </Type>
      <ArrowWrap>
        <LinkArrow fill={colors.deepBlue} />
      </ArrowWrap>
    </ReadMoreContainer>
  )
}
